import React from 'react';
import { XCircle, CheckCircle } from 'lucide-react';

interface SolveStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  type: 'solve' | 'unsolve';
  isPending: boolean;
}

const SolveStatusModal: React.FC<SolveStatusModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  type,
  isPending
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md overflow-hidden">
        <div className="px-6 py-4">
          <div className="flex items-center mb-4">
            {type === 'solve' ? (
              <CheckCircle className="h-6 w-6 text-green-600 mr-2" />
            ) : (
              <XCircle className="h-6 w-6 text-amber-600 mr-2" />
            )}
            <h3 className="text-lg font-medium text-gray-900">
              {type === 'solve' ? 'Mark discussion as solved?' : 'Mark discussion as unsolved?'}
            </h3>
          </div>
          
          <p className="text-gray-600 mb-4">
            {type === 'solve' 
              ? 'Marking this discussion as solved indicates that a satisfactory answer has been provided. This helps others know the issue has been resolved.'
              : 'Marking this discussion as unsolved indicates that a satisfactory answer has not yet been provided. The discussion will appear in unsolved filters.'}
          </p>
        </div>
        
        <div className="bg-gray-50 px-6 py-3 flex justify-end space-x-3">
          <button
            className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            onClick={onClose}
            disabled={isPending}
          >
            Cancel
          </button>
          <button
            className={`px-4 py-2 rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 ${
              type === 'solve'
                ? 'bg-green-600 hover:bg-green-700 focus:ring-green-500'
                : 'bg-amber-600 hover:bg-amber-700 focus:ring-amber-500'
            } ${isPending ? 'opacity-75 cursor-not-allowed' : ''}`}
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending ? (
              <span className="flex items-center">
                <span className="w-4 h-4 mr-2 border-t-2 border-b-2 border-white rounded-full animate-spin"></span>
                Processing...
              </span>
            ) : (
              type === 'solve' ? 'Mark as Solved' : 'Mark as Unsolved'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SolveStatusModal;
